import axios from "./config";
import { AxiosResponse } from "axios";
import { GetMealRatingApiRepsonse, GetRatingsApiResponse, ReportApiResponse } from "app/types/mealRating";

export const getMealRatingApi = (
  query: string,
  storeId: number
): Promise<AxiosResponse<GetMealRatingApiRepsonse>> =>
  axios.get<GetMealRatingApiRepsonse>(`/stores/${storeId}/feedbacks${query}`);

export const getRatingsApi = (
  dishId: number,
  storeId: number
): Promise<AxiosResponse<GetRatingsApiResponse>> =>
  axios.get<GetRatingsApiResponse>(
    `/stores/${storeId}/dishes/${dishId}/feedbacks-stats`
  );

export const getRatingsReportApi = (query:string,storeId:number): Promise<
  AxiosResponse<ReportApiResponse>
> => axios.get<ReportApiResponse>(`/stores/${storeId}/reports/feedback-report${query}`);
